module.exports = __webpack_public_path__ + "static/docs/Vermietungsplane_Tuefwis_Parkplaetze_200129.ed28566f.pdf";